$(document).ready(function() {
    // Function to check if customer spent enough on their first or second order
    function checkPriceSpent() {
        if (!ShopifyAnalytics.meta.page.customerId) return;

        const shop = Shopify.shop;
        const customerId = ShopifyAnalytics.meta.page.customerId;
        const url = "/cart.js";

        // Get the total price from the cart
        $.ajax({
            type: "GET",
            url: url,
            dataType: "json",
            success: function(response) {
                const totalPrice = response.original_total_price / 100;
                // console.log("Total Price",totalPrice);
                let firstOrderWarning = totalPrice < 400;
                let secondOrderWarning = totalPrice < 150;

                handleWarnings(firstOrderWarning, secondOrderWarning, shop, customerId);
            },
            error: function(xhr, status, error) {
                console.error("Error fetching cart data:", error);
            }
        });
    }

    function handleWarnings(firstOrderWarning, secondOrderWarning, shop, customerId) {
        const warningMessage = {
            first: "Please increase the price to be at least $400 or your order will not be accepted.",
            second: "Please increase the price to be at least $150 or your order will not be accepted."
        };

        $.ajax({
            type: "GET",
            url: `/tools/sheababy/?shop=${shop}&customers_id=${customerId}`,
            dataType: "json",
            success: function(response) {
                if (response.status === 200) {
                    const alertDiv = $(".alert_div");
                    const submitButton = $(".ajax-cart__button-submit");
                    const additionalButtons = $(".ajax-cart__buttons-additional");
                    if (firstOrderWarning && response.zero === "true" ) {
                        submitButton.hide();
                        additionalButtons.hide();
                        alertDiv.html(`
                            <div class="alert">
                                <strong>Warning!</strong> ${warningMessage.first}
                            </div>
                        `);
                    } else if (secondOrderWarning && response.zero !== "true") {
                        submitButton.hide();
                        additionalButtons.hide();
                        alertDiv.html(`
                            <div class="alert">
                                <strong>Warning!</strong> ${warningMessage.second}
                            </div>
                        `);
                    }
                  else
                    {
                        submitButton.show();
                        additionalButtons.show();
                    }
                   $('.loader').removeClass('__showloader');
                }
              else
                {
                  console.error("Already Take order:", response);
                  $('.loader').removeClass('__showloader');
                }
            },
            error: function(xhr, status, error) {
                console.error("Error checking price spent:", error);
            }
        });
    }

    // Trigger price check on cart item quantity change
    $(document).on("click", ".ajax-cart__item-quantity", function() {
      $('.loader').addClass('__showloader');
      setTimeout(checkPriceSpent, 1000);
    });

    // Initial check on page load
    checkPriceSpent();

});



// -----------Product Bulk QTY update -------------
$(document).ready(function() {
    function adjustQuantity(element) {
        var inputField = $(element).siblings('input.quantity');
        var currentValue = parseInt(inputField.val(), 10);
       if (isNaN(currentValue) || currentValue < 1) {  currentValue = 1;  }
        var qtyItems = $(".qtyItem");
        qtyItems.each(function() {
            $(this).val(currentValue);
        });
    }
    $('.quantity-control-down , .quantity-control-up').click(function() {
        adjustQuantity(this);
    });
});




